export const HISTORY_FILTER_ALL = 'all';
export const HISTORY_GARAGE_NONE = 'none';

const historyCollator = new Intl.Collator('fr-FR', {
  numeric: true,
  sensitivity: 'base',
});

const normalizeText = (value) => String(value || '').trim().toLocaleLowerCase('fr-FR');
const normalizeSearchText = (value) => normalizeText(value)
  .normalize('NFD')
  .replace(/[\u0300-\u036f]/g, '');

const getLocalDateValue = (value) => {
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

export const getHistoryEntretienFilterValue = (item) => {
  if (item?.EntretienTypeID !== null && item?.EntretienTypeID !== undefined) {
    return `id:${item.EntretienTypeID}`;
  }

  return `name:${normalizeText(item?.EntretienType?.Nom)}`;
};

export const getHistoryGarageFilterValue = (item) => {
  const garage = normalizeText(item?.Garage);
  return garage ? `garage:${garage}` : HISTORY_GARAGE_NONE;
};

export const buildHistoryFilterOptions = (items, kind) => {
  const options = new Map();

  items.forEach((item) => {
    const isEntretien = kind === 'entretien';
    const value = isEntretien
      ? getHistoryEntretienFilterValue(item)
      : getHistoryGarageFilterValue(item);
    const label = isEntretien
      ? (String(item?.EntretienType?.Nom || '').trim() || 'Sans entretien')
      : (String(item?.Garage || '').trim() || 'Sans garage');

    if (!options.has(value)) options.set(value, { value, label });
  });

  return Array.from(options.values()).sort((a, b) => historyCollator.compare(a.label, b.label));
};

export const filterHistoryItems = (
  items,
  entretienFilter,
  garageFilter,
  { date = '', vehicle = '', note = '' } = {}
) => {
  const vehicleQuery = normalizeSearchText(vehicle);
  const noteQuery = normalizeSearchText(note);

  return items.filter((item) => (
    (entretienFilter === HISTORY_FILTER_ALL || getHistoryEntretienFilterValue(item) === entretienFilter)
    && (garageFilter === HISTORY_FILTER_ALL || getHistoryGarageFilterValue(item) === garageFilter)
    && (!date || getLocalDateValue(item?.Date) === date)
    && (!vehicleQuery || normalizeSearchText(item?.Vehicule?.Nom).includes(vehicleQuery))
    && (!noteQuery || normalizeSearchText(item?.Note).includes(noteQuery))
  ));
};

const getHistorySortValue = (item, key) => {
  switch (key) {
    case 'date': {
      const timestamp = new Date(item?.Date).getTime();
      return Number.isFinite(timestamp) ? timestamp : 0;
    }
    case 'vehicle':
      return normalizeText(item?.Vehicule?.Nom);
    case 'entretien':
      return normalizeText(item?.EntretienType?.Nom);
    case 'garage':
      return normalizeText(item?.Garage);
    case 'note':
      return normalizeText(item?.Note);
    case 'files':
      return Array.isArray(item?.EntretienFichiers) ? item.EntretienFichiers.length : 0;
    case 'cost':
      return Number(item?.Cout) || 0;
    default:
      return 0;
  }
};

export const sortHistoryItems = (items, sort) => [...items].sort((a, b) => {
  const left = getHistorySortValue(a, sort.key);
  const right = getHistorySortValue(b, sort.key);
  const comparison = typeof left === 'string'
    ? historyCollator.compare(left, right)
    : left - right;

  if (comparison !== 0) return sort.direction === 'asc' ? comparison : -comparison;

  return (Number(b?.EntretienRealiseID) || 0) - (Number(a?.EntretienRealiseID) || 0);
});
